import { ref } from "#imports";
export function useOpen(isOpen = ref(false), emit) {
  function open() {
    updateState(true);
  }
  function close() {
    updateState(false);
  }
  function updateState(newState) {
    isOpen.value = newState;
    if (!newState) {
      emit("close");
    }
  }
  function toggle() {
    updateState(!isOpen.value);
  }
  return {
    isOpen,
    open,
    close,
    toggle
  };
}
